module.exports = function aNofollow(md) {
  md.inline.ruler.push('nofollow', function replace(state, silent) {
    if (silent) {
      return false;
    }

    const start = state.pos;
    const expect = '{nofollow}';
    const markLength = expect.length;

    if (state.src.charAt(start) !== '{') {
      return false;
    }

    const mark = state.src.substr(start, markLength);
    if (mark !== expect) {
      return false;
    }

    const lastToken = state.tokens[state.tokens.length - 1];
    if (!lastToken || lastToken.type !== 'link_close') {
      return false;
    }

    let expectedLinkOpenIndex = -1;

    // 最後から最も近い link_open トークンを探す
    for (let i = state.tokens.length - 1; i >= 0; i--) {
      if (state.tokens[i].type === 'link_open') {
        expectedLinkOpenIndex = i;
        break;
      }
    }
    if (expectedLinkOpenIndex === -1) {
      return false;
    }

    state.pos = start + markLength;

    state.tokens[expectedLinkOpenIndex].attrs.push(['rel', 'nofollow']);

    return true;
  });
};
